import React from 'react'
import { Card } from 'react-bootstrap';
import tipsImg from '../../../media/images/tipsImg.png'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import Finance from './finance';
import { useNavigate } from 'react-router-dom';
import { txtTipsAndTricks } from '../../../dataBaseFile/label';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
    labels: ['Personal', 'Phone', 'Traveling', 'Other',],
    datasets: [
        {
            label: '# of Votes',
            data: [12, 19, 13, 5,],
            backgroundColor: [
                '#FF8934',
                '#FDAD9B',
                '#4FD18B',
                '#F65160',
            ],
            // borderColor: [
            //     // 'orange',
            //     // 'light-red',
            //     // 'green',
            //     // 'pink'
            // ],
            borderWidth: 1,
            // hoverBackgroundColor: 'rgba(255, 99, 132, 0.2)',
            // hoverBorderColor: 'rgba(255, 99, 132, 1)',
        },
    ],
};

const options = {
    responsive: false,
    maintainAspectRatio: false,
    interaction: {
        mode: 'nearest',
        intersect: false,
        axis: 'x'
    },
    legend: {
        position: 'right', // change the position here
        labels: {
            boxWidth: 20,
            font: {
                size: '12px',  // adjust the font size here
            }
        },
        onClick: (e) => e.stopPropagation()
    },
    plugins: {
        tooltip: {
            enabled: false
        },
    },
    layout: {
        padding: 0,
    },
};

// const options = {
//     responsive: false,
//     maintainAspectRatio: false,
//     plugins: {
//         tooltip: {
//             enabled: false
//         },
//     }
// };

const TotalEarning = () => {
    const navigate = useNavigate()
    const tips = [
        {
            id: 1,
            title: 'Profile completion',
            subTitle: 'Make sure your profile is up-to-date to get the most out of Chilll',
        },
        {
            id: 2,
            title: 'Partnering with contractors of all sizes',
            subTitle: 'Help eliminate nuisance calls and optimize',
        },
        {
            id: 3,
            title: 'How we help your industry',
            subTitle: 'Reducing Truck Rolls Through Remote Diagnosis',
        },
    ]

    const handleGoToProfile = (i) => {
        if (i == 0) {
            navigate('/userProfile')
        }
    }

    return (
        <>
            <div className='total-earning-container'>

                {/* <Card className='total-earning-card' style={{ padding: '1rem' }}>
                    <p className='finance-para' style={{ fontSize: '14px', fontWeight: 700, color: 'black' }}>Total Earning This Month</p>

                    <div className='d-flex justify-content-center' style={{ width: '100%', height: '90%' }}>
                        <Doughnut data={data} options={options} style={{ width: '60%', cursor: 'pointer'}} />
                    </div>

                </Card> */}

                <div className='sub-container' style={{ height: '245px', width: '100%' }}>
                    <Finance />
                </div>

                <Card className='total-earning-card total-earning-card-bottom'>
                    <p className='finance-para' style={{ fontSize: '16px', fontWeight: 700, color: 'black' }}>{txtTipsAndTricks}</p>
                    <img className='tips-img' src={tipsImg} alt='.' />

                    {tips.map((element, i) => {
                        return (
                            <div key={i} onClick={() => handleGoToProfile(i)} className='transaction-sub-content-left' style={{ zIndex: 1, cursor: i == 0 && 'pointer' }}>
                                <div className='transaction-sub-content-left-icon'
                                    style={{
                                        color: 'white',
                                        backgroundColor: '#4FD18B',
                                        fontWeight: 900,
                                        fontSize: '18px'
                                    }}
                                >
                                    {element.id}
                                </div>
                                <div className='transaction-sub-content-left-info'>
                                    <span style={{ color: 'black', fontWeight: '700' }}>{element.title}</span>
                                    <span>{element.subTitle}</span>
                                </div>
                            </div>
                        )
                    })}
                </Card>
            </div>
        </>
    )
}

export default TotalEarning;